import { render, staticRenderFns } from "./dict-select.vue?vue&type=template&id=4163070b"
import script from "./dict-select.vue?vue&type=script&lang=ts"
export * from "./dict-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports